// extracted by mini-css-extract-plugin
export default {"wrap":"uG-z","fullWidth":"vG-z","hideOnDesktop":"wG-z","content":"xG-z","hasOpenedNav":"yG-z","crumbsList":"zG-z","dropdownsWrap":"AG-z"};